export const Flag = ({ code, className = "", style }) => (
  <img src={`https://flagcdn.com/w80/${code.toLowerCase()}.png`} alt={`${code} flag`} loading="lazy"
    className={`object-cover ${className}`} style={style} draggable={false} />
);
export default Flag;
